import { Action } from '@ngrx/store';

export const LOGIN_USER = '[Auth] Logging in user...';
export const LOGOUT_USER = '[Auth] Logging out user...';

export class LoginUserAction implements Action {
    readonly type = LOGIN_USER;
}

export class LogoutUserAction implements Action {
    readonly type = LOGOUT_USER;
}

export type authActions = LoginUserAction | LogoutUserAction;
